import { Modal } from 'common-front/src/designSystem/components/modal/modal';
import { TextInput } from 'common-front/src/designSystem/components/textInput';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Box } from 'common/src/designSystem/components/box';
import { Cell } from 'common/src/designSystem/components/table/cell';
import { HeaderCell } from 'common/src/designSystem/components/table/headerCell';
import { HeaderRow } from 'common/src/designSystem/components/table/headerRow';
import { Row } from 'common/src/designSystem/components/table/row';
import { Table } from 'common/src/designSystem/components/table/table';
import { CountriesService } from 'common/src/services/countriesService';
import { toArray } from 'common/src/util/array';
import { useService } from 'common/src/util/dependencies/dependencies';
import { isNonEmptyString, normalize } from 'common/src/util/string';
import { applyMarkup } from 'common/src/vo/sms';
import { round } from 'lodash-es';
import * as React from 'react';

export const CampaignSmsPricesModal = () => {
    const { translate } = useHeavent();
    const countriesService = useService(CountriesService);
    const [name, setName] = React.useState('');
    const countriesWithSmsPrice = React.useMemo(
        () => countriesService.countries.filter((country) => typeof country.smsPrice === 'number'),
        [countriesService]
    );
    const filteredCountries = React.useMemo(() => {
        if (isNonEmptyString(name)) {
            const normalizedName = normalize(name.toLowerCase());

            return countriesWithSmsPrice.filter(
                (country) =>
                    normalize(country.name.toLowerCase()).includes(normalizedName) ||
                    toArray(country.phoneCode).some((phoneCode) => phoneCode.includes(name))
            );
        } else {
            return countriesWithSmsPrice;
        }
    }, [countriesWithSmsPrice, name]);

    return (
        <Modal.Root>
            <Modal.Trigger>
                <Box color="primary700">{translate('voir_la_liste_d_69122')}</Box>
            </Modal.Trigger>

            <Modal.Portal>
                <Modal.Header icon="message">{translate('liste_des_prix_58579')}</Modal.Header>

                <Modal.Content css={{ overflow: 'auto' }} direction="column" gap="3" height={300}>
                    <TextInput
                        icon="magnifying-glass"
                        placeholder="Rechercher un pays"
                        state="search"
                        value={name}
                        onChange={setName}
                    />

                    <Table>
                        <HeaderRow>
                            <HeaderCell>{translate('Country')}</HeaderCell>
                            <HeaderCell>{translate('indicatif_40634')}</HeaderCell>
                            <HeaderCell>{translate('prix_ht_10965')}</HeaderCell>
                        </HeaderRow>

                        {filteredCountries.map((country) => (
                            <Row key={country.code}>
                                <Cell>{country.name}</Cell>
                                <Cell>{country.phoneCode}</Cell>
                                <Cell>{round(applyMarkup(country.smsPrice!), 3)}</Cell>
                            </Row>
                        ))}
                    </Table>
                </Modal.Content>

                <Modal.Buttons />
            </Modal.Portal>
        </Modal.Root>
    );
};
